export const getIconInfo = (
  cover: string,
  name: string,
  marker?: any,
  widthHeight = 16,
  fontSize = 12,
) => {
  return `${
    marker ? `<span class="chart-common-formatter-marker">${marker}</span>` : ''
  }
          <img style="width: ${widthHeight}px;height: ${widthHeight}px;margin-right: 4px;border-radius: 4px;vertical-align: middle;"  src=${cover}></img>
          <span style="font-size: ${fontSize}px;" >${name}</span>`;
};

export const getStarElement = (ele: any, starNum: number) => {
  let elements = '';
  for (let index = 0; index < starNum; index++) {
    elements += ele;
  }

  return elements;
};
